import { useEffect, useMemo } from "react";
import updateFavicon, { BuildState } from "~/lib/Favicon";
import { Build } from "~/components/build/Show/lib/types";
import { useFaviconPathsStore } from "~/components/build/Show/lib/useFaviconPathsStore";
import { Current } from "~/utils/Current";

const BLOCKED_STATE_MAPPINGS: Record<string, BuildState> = {
  failed: "failed",
  running: "started",
  passed: "passed",
  blocked: "blocked",
} as const;

const STATE_MAPPINGS: Record<string, BuildState> = {
  failed: "failed",
  failing: "failed",
  canceled: "canceled",
  canceling: "canceled",
  not_run: "failed",
  passed: "passed",
  started: "started",
  blocked: "blocked",
} as const;

/**
 * Update the favicon based on the build state.
 */
export default function useBuildFavicon(build: Build) {
  const faviconPaths = useFaviconPathsStore((state) => state.faviconPaths);
  const isImpersonating = Current.user.impersonating;

  const faviconState = useMemo(() => {
    if (build.state === "blocked" && build.blockedState) {
      return BLOCKED_STATE_MAPPINGS[build.blockedState] ?? "passed";
    }

    return STATE_MAPPINGS[build.state] ?? "scheduled";
  }, [build.state, build.blockedState]);

  useEffect(() => {
    updateFavicon(faviconPaths, faviconState, isImpersonating);
  }, [faviconPaths, faviconState, isImpersonating]);
}
